export function getTemplateData(key, templateData) {
    const res = templateData[key];
    if (!res) {
        console.error(`Missing template data for key: ${key}`);
    }
    return res;
}
export function roundPrice(price, currency) {
    if (price === 0)
        return 0;
    const temp = typeof price === 'string' ? parseFloat(price) : price;
    if (!currency.rounding)
        return temp;
    const pow = Math.pow(10, currency.rounding);
    return Math.round(temp / pow) * pow;
}
export function formatPrice(price, currency, rounding = false) {
    const temp = typeof price === 'string' ? parseFloat(price) : price;
    let roundedPrice = rounding ? roundPrice(temp, currency) : temp;
    if (currency.decimal_places !== null) {
        roundedPrice = roundedPrice.toFixed(currency.decimal_places);
    }
    const parts = roundedPrice.toString().split('.');
    const decimalPart = parts[1];
    let numberPart = parts[0];
    if (currency.separator) {
        const thousands = new RegExp(`\\B(?=(\\d{${currency.separator}})+(?!\\d))`, 'g');
        numberPart = numberPart.replace(thousands, String.fromCharCode(currency.separator_unit));
    }
    const formattedPrice = `${numberPart + (decimalPart ? currency.decimal_point + decimalPart : '')}`;
    if (currency.position) {
        return `${formattedPrice} ${currency.symbol}`;
    }
    return `${currency.symbol} ${formattedPrice}`;
}
export function computePriceWithDiscount(price, discount) {
    return price - (price * discount) / 100;
}
export function computePriceBeforeDiscount(price, discount) {
    return price / (1 - discount / 100);
}
export function getCsfrToken() {
    const element = document.querySelector(`meta[name="csrf-token"]`);
    if (!element) {
        throw new Error('Missing csrf token');
    }
    const value = element.getAttribute('content');
    if (!value) {
        throw new Error('Missing csrf token');
    }
    return value;
}
